export const CLASS_NAME = 'cst-component-loader'
